import React, { useMemo } from "react"
import { Box, Text } from "@chakra-ui/react"

type Props = {
  product: any
}

const ProductDescription = ({ product }: Props) => {
  const styleCode = useMemo(() => product?.tags?.find((tag: any) => tag.indexOf("ap21:code:") != -1)?.split(":")?.[2], [product?.tags])
  return (
    <Box>
      {product?.descriptionHtml ? <Text className="standard-list" dangerouslySetInnerHTML={{ __html: product?.descriptionHtml }} /> : null}
      {styleCode && <Text>Style: {styleCode}</Text>}
    </Box>
  )
}

export default React.memo(ProductDescription)
